'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    'use strict';

    // @ngInject

    Services.Drift = function Drift($window) {
        var pendingCallbacks = [];
        var wrapper = {
            instantiate: function instantiate() {
                $window.drift||function() {var t; if (t = window.driftt = window.drift = window.driftt || [], !t.init) return t.invoked ? void (window.console && console.error && console.error("Drift snippet included twice.")) : (t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], t.factory = function(e) {return function() {var n;return n = Array.prototype.slice.call(arguments), n.unshift(e), t.push(n), t;};}, t.methods.forEach(function(e) {t[e] = t.factory(e);}), t.load = function(t) {var e, n, o, i;e = 3e5, i = Math.ceil(new Date() / e) * e, o = document.createElement("script"), o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + i + "/" + t + ".js", n = document.getElementsByTagName("script")[0], n.parentNode.insertBefore(o, n);});}();
                //register callbacks
                $window.drift.on('ready', function() {
                    pendingCallbacks.forEach(function (arr) {
                        $window.drift.on(arr[0], arr[1]);
                    });
                });
            },
            configure: function configure() {
                $window.drift.SNIPPET_VERSION = '0.3.1';
                $window.drift.load('zudyixi77yer');
            },
            identify: function identify(currUser, currCompany) {
                $window.drift.identify(currUser._id,{
                    email: currUser.email,
                    phoneNumber: currCompany.phone_number,
                    name: currUser.full_name,
                    companyId: currCompany._id,
                    companyType: currCompany.company_type,
                    startDate: (currUser.getTrial() && (new Date(currUser.getTrial().start_date).getTime() / 1000).toFixed(0)),
                    subscribed: currUser.companyHasSubscription()
                });
            },
            update: function update(currUser, currCompany) {
                currUser.getAECalendlyLink().then(function(resp){
                    $window.drift.identify(currUser._id,{ae_calendly_link: resp.data.ae_calendly_link})
                });

                currUser.getSfdcRecordOwnerEmail().then(function(resp){
                    $window.drift.identify(currUser._id,{sfdc_record_owner_email: resp.data.sfdc_record_owner_email})
                });

                currUser.getSfdcRecord().then(function(resp){
                    $window.drift.identify(currUser._id,{sfdc_record: resp.data.sfdc_record})
                });
            },
            open: function open() {
                if($window.drift && $window.drift.api) {
                    $window.drift.api.openChat();
                }
            },
            hide: function hide() {
                if($window.drift) {
                    $window.drift.hide(); //same as: this.$window.drift.api.widget.hide();
                }
            },
            show: function show() {
                if($window.drift) {
                    $window.drift.show(); //same as: this.$window.drift.api.widget.show();
                }
            },
            //possible events are documented at: https://devdocs.drift.com/docs/drift-events#section-conversation-started
            registerCallback: function registerCallback(driftEvent, callback) {
                if ($window.drift) {
                    $window.drift.on(driftEvent, callback);
                } else {
                    pendingCallbacks.push([driftEvent, callback]);
                }
            }
        };
        return wrapper;
    };
})();